import { Component, Inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ClientSetup } from '../../../../models/client';
import { InstanceTypes } from '../../../../models/instance-types';
import {
  PayrollStartConfig,
  PayrollStartData,
  PayrollStatuses,
  PayTypes
} from '../../../../models/payroll';
import { AuthService } from '../../../../services/auth.service';
import { PayrollService } from '../../../../services/payroll.service';
import { PayrollManagement } from '../../../../tools/payroll-management';
import { IsPayDateInvalid } from '../PaydateValidationFunction';
import { ModalStates } from '../../../../models/modal';
import { ModalService } from '../../../../services/modal.service';

@Component({
  selector: 'lib-off-cycle-payroll-tile',
  templateUrl: './off-cycle-payroll-tile.component.html',
  styleUrls: ['./off-cycle-payroll-tile.component.css'],
  standalone: false
})
export class OffCyclePayrollTileComponent implements OnInit {
  @Input() public clientCode: string;
  @Input() public clientSetup: ClientSetup;
  @Input() public payrollStartData: PayrollStartData;
  @Input() public prefundWarnings: string[];

  public payrollStartConfig: PayrollStartConfig;

  get isPayDateInvalid() {
    return (
      this.payrollStartData?.ActivePayroll?.PayType == PayTypes.OffCycle &&
      IsPayDateInvalid(this.payrollStartData?.ActivePayroll)
    );
  }

  get isClientPortal() {
    return this.env.instanceType == InstanceTypes.ClientPortal;
  }

  get isPrefundLocked() {
    return (
      this.isClientPortal &&
      this.prefundWarnings?.length &&
      this.payrollStartData.ActivePayroll == null
    );
  }

  get disableButton() {
    return this.payrollStartConfig.IsLocked || this.isPrefundLocked;
  }

  get activePayrollLock() {
    if (this.payrollStartData.ActivePayroll == null) {
      return false;
    }

    if (this.payrollStartData.ActivePayroll.PayType == PayTypes.OffCycle) {
      return false;
    }

    // there is a manual check payroll, and it is being actively edited, lock
    if (
      this.payrollStartData.ActivePayroll.PayType == PayTypes.Manual &&
      this.payrollStartData.ActivePayroll.Status != PayrollStatuses.Started
    ) {
      return false;
    }

    return true;
  }

  get buttonText() {
    let text = 'Start Off-Cycle Payroll';
    if (this._offCyclePayrollInProgress()) {
      text = 'Resume Off-Cycle Payroll';
    }
    return text;
  }

  constructor(
    private router: Router,
    private authService: AuthService,
    private payrollMgmt: PayrollManagement,
    private payrollService: PayrollService,
    private modalService: ModalService,
    @Inject('env') private env: any
  ) {}

  ngOnInit(): void {
    this.payrollStartConfig = this.payrollMgmt.buildPayrollConfig(
      this.clientSetup,
      this.payrollStartData?.ActivePayroll,
      null,
      PayTypes.OffCycle,
      this.payrollStartData
    );
  }

  navigatePayroll() {
    if (this._offCyclePayrollInProgress()) {
      // the payroll has been started. take user to payroll start/home screen
      this.router.navigate([`/client/${this.clientCode}/payroll/`], {
        queryParams: { payType: 3 }
      });
    } else {
      this.router.navigate([`/client/${this.clientCode}/manual-checks`], {
        queryParams: { payType: 3 }
      });
    }
  }

  cancelPayroll() {
    if (this._offCyclePayrollInProgress()) {
      this.payrollService
        .cancelPayroll(
          this.payrollStartData.ActivePayroll.ClientCode,
          this.payrollStartData.ActivePayroll.Year,
          this.payrollStartData.ActivePayroll.SequenceNumber,
          true
        )
        .subscribe(
          () => window.location.reload(),
          err => {
            if (err.status !== 404) {
              this.modalService.showAlertModal(
                `Error Code: ${err.status}\nMessage: An Error has Occurred`,
                ModalStates.Error
              );
            }
            window.location.reload();
          }
        );
    }
  }

  private _offCyclePayrollInProgress() {
    return (
      this.payrollStartData.ActivePayroll != null &&
      this.payrollStartData.ActivePayroll.PayType == PayTypes.OffCycle
    );
  }
}
